import axios from 'axios'
import { Filter } from '../../../components/_WMS/FilterComponent'
import { ApiConfig } from '../../../config/api'
import { utcFinalDate, utcIntialDate } from '../../../utils/dateHelper'

export const GetStockBatchDetailAsync = (
  stockKeepingUnitId: number,
  positionId: number,
  page = 0,
  pageSize = 5
) => {
  const url = new URL(
    `${ApiConfig.StockApi}/GetStockBatchDetail/${stockKeepingUnitId}/position/${positionId}/batches?pageIndex=${page}&pageSize=${pageSize}`
  )

  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  return axios.get(url.toString())
}

export const postExportStockMasive = (filters?: Filter[]) => {
  const url = new URL(`${ApiConfig.ProcessApi}/ExportStockMasive`)
  const jsonObject = filters?.reduce((acc, filter) => {
    acc[filter.key] = filter.value
    return acc
  }, {} as Record<string, any>)
  return axios.post(url.toString(), jsonObject)
}

export const getStock = (filters: Filter[], page: number, pageSize: number) => {
  const url = new URL(`${ApiConfig.StockApi}`)

  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (filters) {
    filters.forEach((element) => {
      if (element.key === 'initialDateFilter') {
        url.searchParams.set(element.key, utcIntialDate(element.value))
      } else if (element.key === 'finalDateFilter') {
        // Cambié esto - era 'initialDate' duplicado
        url.searchParams.set(element.key, utcFinalDate(element.value))
      } else {
        url.searchParams.append(element.key, element.value.toString())
      }
    })
  }
  return axios.get(url.toString())
}
